import DefaultMessage from "components/Common/DefaultMessage/DefaultMessage.tsx";
import TableSkeleton from "components/Common/Table/TableSkeleton/TableSkeleton.tsx";
import { LeadAssignmentsTable } from "features/LeadGen/pages/LeadAssignments/components/LeadAssignmentsTable/LeadAssignmentsTable.tsx";
import { LeadAssignmentsTab } from "features/LeadGen/pages/LeadAssignments/components/LeadAssignmentsTabs/LeadAssignmentsTabs.tsx";
import { models } from "types/api/viewModels.ts";
import * as Text from "../../LeadAssignmentsPage.text";
import {
	LeadAssignmentsPageTableContainer,
	LeadAssignmentsPageTableHelperText
} from "./LeadAssignmentsContent.styles.ts";

export interface LeadAssignmentsContentProps {
	isLoading: boolean;
	hasLeads: boolean;
	hasCurrentTabLeads?: boolean;
	currentTab?: LeadAssignmentsTab;
	filteredLeads: models["LeadAssignmentViewModel"][];
}

export const LeadAssignmentsContent = ({
	isLoading,
	hasLeads,
	hasCurrentTabLeads = true,
	currentTab = "open",
	filteredLeads
}: LeadAssignmentsContentProps) => {
	if (isLoading) return <TableSkeleton />;

	if (!hasLeads) {
		return (
			<DefaultMessage
				dataTestId="default-message-no-leads"
				asset="/assets/NoOrdersSadBoxImage.svg"
				altMessage="No leads available"
				title={Text.NoLeadsYet}
				subtitle={Text.NoLeadsYetSubText}
				removeHeight
			/>
		);
	}

	if (currentTab === "unassigned" && !hasCurrentTabLeads) {
		return (
			<DefaultMessage
				dataTestId="default-message-no-unassigned-leads"
				asset="/assets/NoOrdersSadBoxImage.svg"
				altMessage="All leads have been assigned"
				title={Text.NoUnassignedLeadsText}
				subtitle={Text.NoUnassignedLeadsSubText}
				removeHeight
			/>
		);
	}

	if (!filteredLeads.length) {
		return (
			<DefaultMessage
				dataTestId="default-message-no-filtered-leads"
				asset="/assets/NoOrdersSadBoxImage.svg"
				altMessage="No leads match filters"
				title={Text.NoLeadsText}
				subtitle={Text.NoLeadsSubText}
				bullets={[Text.NoLeadsBullet1, Text.NoLeadsBullet2, Text.NoLeadsBullet3, Text.NoLeadsBullet4]}
				removeHeight
			/>
		);
	}

	return (
		<>
			<LeadAssignmentsPageTableHelperText>{Text.LeadsAreAvailableText}</LeadAssignmentsPageTableHelperText>
			<LeadAssignmentsPageTableContainer>
				<LeadAssignmentsTable leads={filteredLeads} />
			</LeadAssignmentsPageTableContainer>
		</>
	);
};
